import(/* webpackMode: "eager" */ "/app/app/root/[domain]/[lang]/not-found.tsx");
